import React from 'react'
import cx from 'classnames'
import theme from './theme.scss'

export const SimpleButton = React.forwardRef(
  ({ className, disabled, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cx(theme.button, theme.simpleButton, className, {
          [theme.disabled]: disabled,
        })}
        disabled={disabled}
        {...props}
      />
    )
  }
)

SimpleButton.displayName = 'SimpleButton'

export const PrimaryButton = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <SimpleButton
        ref={ref}
        className={cx(theme.primary, className)}
        {...props}
      />
    )
  }
)

PrimaryButton.displayName = 'PrimaryButton'

export const SecondaryButton = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <SimpleButton
        ref={ref}
        className={cx(theme.secondary, className)}
        {...props}
      />
    )
  }
)

SecondaryButton.displayName = 'SecondaryButton'
